module.exports = __webpack_public_path__ + "52c4895d8fbb1e1ab3d8958be2856edf.svg";